var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodeCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/code-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "code-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.50016 1.73663C4.82016 1.73663 1.8335 4.7233 1.8335 8.4033C1.8335 12.0833 4.82016 15.07 8.50016 15.07C12.1802 15.07 15.1668 12.0833 15.1668 8.4033C15.1668 4.7233 12.1802 1.73663 8.50016 1.73663ZM6.18683 9.3833C6.38016 9.57663 6.38016 9.89663 6.18683 10.09C6.08683 10.19 5.96016 10.2366 5.8335 10.2366C5.70683 10.2366 5.58016 10.19 5.48016 10.09L4.14683 8.75663C3.9535 8.5633 3.9535 8.2433 4.14683 8.04997L5.48016 6.71663C5.6735 6.5233 5.9935 6.5233 6.18683 6.71663C6.38016 6.90997 6.38016 7.22997 6.18683 7.4233L5.20683 8.4033L6.18683 9.3833ZM9.62683 7.0433L8.2935 10.1566C8.2135 10.3433 8.02683 10.4566 7.8335 10.4566C7.76683 10.4566 7.70016 10.4433 7.64016 10.4166C7.38683 10.31 7.26683 10.0166 7.38016 9.75663L8.7135 6.6433C8.82016 6.38997 9.1135 6.26997 9.36683 6.3833C9.62016 6.49663 9.7335 6.78997 9.62683 7.0433ZM12.8535 8.75663L11.5202 10.09C11.4202 10.19 11.2935 10.2366 11.1668 10.2366C11.0402 10.2366 10.9135 10.19 10.8135 10.09C10.6202 9.89663 10.6202 9.57663 10.8135 9.3833L11.7935 8.4033L10.8135 7.4233C10.6202 7.22997 10.6202 6.90997 10.8135 6.71663C11.0068 6.5233 11.3268 6.5233 11.5202 6.71663L12.8535 8.04997C13.0468 8.2433 13.0468 8.5633 12.8535 8.75663Z",
    fill: "#B36CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeCircle);
export default __webpack_public_path__ + "static/media/code-circle.c640f8baec0aecc6c77478392eae26a4.svg";
export { ForwardRef as ReactComponent };